import { render, staticRenderFns } from "./ShortcutMenuPop.vue?vue&type=template&id=38225e04&scoped=true"
import script from "./ShortcutMenuPop.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutMenuPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShortcutMenuPop.vue?vue&type=style&index=0&id=38225e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38225e04",
  null
  
)

export default component.exports